import { jsxs as n, jsx as l } from "react/jsx-runtime";
const f = ({
  label: a,
  id: s,
  options: r,
  onChange: t,
  className: o = "",
  defaultValue: h,
  rightIcon: m,
  leftIcon: c,
  innerRef: v,
  ...u
}) => {
  var i;
  const p = `dropdown-styling ${c ? "menu-with-left-icon" : ""} ${o}`;
  return /* @__PURE__ */ n("span", { className: p, children: [
    /* @__PURE__ */ l("label", { htmlFor: s, children: a }),
    /* @__PURE__ */ n("div", { className: "select-wrapper", children: [
      /* @__PURE__ */ l(
        "select",
        {
          defaultValue: h,
          value: (i = r.find((e) => e.selected)) == null ? void 0 : i.value,
          id: s,
          ref: v,
          onChange: ({ target: e }) => {
            const d = r.find((w) => w.value === e.value) ?? r[0];
            t(d);
          },
          ...u,
          children: r.map((e, d) => /* @__PURE__ */ l("option", { value: e.value, children: e.title }, `dropdown-${a}-${e.title}-${d}`))
        }
      ),
      /* @__PURE__ */ n("div", { children: [
        /* @__PURE__ */ l("div", { className: "left-icon", children: c }),
        /* @__PURE__ */ l("div", { className: "right-icon", children: m })
      ] })
    ] })
  ] });
};
f.displayName = "Dropdown";
export {
  f as D
};
